import { render, staticRenderFns } from "./ruleExplainModal.vue?vue&type=template&id=0aadf612&scoped=true"
import script from "./ruleExplainModal.vue?vue&type=script&lang=js"
export * from "./ruleExplainModal.vue?vue&type=script&lang=js"
import style0 from "./ruleExplainModal.vue?vue&type=style&index=0&id=0aadf612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadf612",
  null
  
)

export default component.exports